import React from 'react';
import {Box, Grid} from '@mui/material';
import {AutoField} from '../../../components/AutoForm/AutoFieldNew';
import {BuilderPot, BuilderPot_dentistChildren} from '../../../schema-types/BuilderPot';
import {setUpAnnuityFields} from './builderAnnuityFields';
import {
  transferFullField as fullField,
  transferAmountField as amountField,
} from '../BuilderTransfer/builderTransferFields';
import {InitialBuilderFeeField} from '../CreateBuilder/BuilderInitialFeesField';
import {useAutoField} from '../../../components/AutoForm/useAutoForm';
import {useSetAnnuityFullAmount} from '../hooks/builderAnnuityHooks';

interface BuilderAnnuitySourceFormProps {
  // eslint-disable-next-line react/no-unused-prop-types
  pot: BuilderPot | BuilderPot_dentistChildren;
  maxAmount?: number;
}

export const BuilderAnnuitySourceForm = ({maxAmount}: BuilderAnnuitySourceFormProps) => {
  const [annuityField] = useAutoField<setUpAnnuityFields | undefined>('annuity');
  useSetAnnuityFullAmount({maxAmount});

  return (
    <Grid item xs={12}>
      <Box>
        <Grid container direction="column" spacing={4}>
          <Grid item>
            <Grid alignItems="center" container direction="row" spacing={2}>
              <Grid item xs={6}>
                <InitialBuilderFeeField formikKeyPrefixWithoutFee="annuity" />
              </Grid>
              <Grid item xs={6}>
                <AutoField
                  field={{...fullField, id: 'annuity.full', label: 'Full transfer?'}}
                />
              </Grid>
              <Grid item xs={6}>
                <AutoField
                  field={{
                    ...amountField,
                    disabled: annuityField.value?.full || false,
                    label: 'Transfer amount',
                    id: 'annuity.singleClientAmount',
                  }}
                  disabled={annuityField.value?.full}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};
